import React, {useCallback} from 'react';
import {
    ChallengeDropdown,
    UserDropdown,
    DatePicker,
    ListPage,
    filterConstants,
    catchQueryFilters
} from "mindsets-js-sdk";

import Table from "./Table";
import {LoadActionLogsAction} from "../../actions/action_log_actions";

export default function () {
    const debounce = useCallback(_.debounce(a => a(), 600), []);

    return (
        <>
            <h1>Action Logs</h1>
            <ListPage
                action={options => LoadActionLogsAction(Object.assign({
                    'selectors[0]': 'user',
                    'selectors[1]': 'lesson',
                    'selectors[2]': 'challengeVersion.challengeCode'
                }, options))}
                filter_columns={[
                    {
                        key: 'lesson_id',
                        name: 'Lesson ID',
                        expressions: [filterConstants.EXPRESSION_EQUAL, filterConstants.EXPRESSION_NOT_EQUAL, filterConstants.EXPRESSION_IN]
                    },
                    {
                        key: 'lesson_code',
                        name: 'Class Code',
                        expressions: [filterConstants.EXPRESSION_EQUAL, filterConstants.EXPRESSION_NOT_EQUAL, filterConstants.EXPRESSION_CONTAINS, filterConstants.EXPRESSION_NOT_CONTAINS, filterConstants.EXPRESSION_IN]
                    },
                    {
                        key: 'challenge_version_id',
                        name: 'Challenge version',
                        expressions: [filterConstants.EXPRESSION_EQUAL],
                        component: setFilterValue => {
                            return (
                                <ChallengeDropdown
                                    onSelect={challenge_version => {
                                        if (challenge_version) {
                                            setFilterValue(challenge_version.id);
                                        } else {
                                            setFilterValue('');
                                        }

                                        return challenge_version ? challenge_version.name : '';
                                    }}
                                    unversioned={true}
                                    id='lessons-challenge-version-filter'
                                    debounce={debounce}
                                />
                            );
                        },
                        multiple: false
                    },
                    {
                        key: 'challenge_code',
                        name: 'Challenge',
                        expressions: [filterConstants.EXPRESSION_EQUAL],
                        component: setFilterValue => {
                            return (
                                <ChallengeDropdown
                                    onSelect={challenge_version => {
                                        if (challenge_version) {
                                            setFilterValue(challenge_version.challenge_code.code);
                                        } else {
                                            setFilterValue('');
                                        }

                                        return challenge_version ? challenge_version.name : '';
                                    }}
                                    id='lessons-challenge-code-filter'
                                    debounce={debounce}/>
                            );
                        },
                        multiple: false
                    },
                    {
                        key: 'created_at',
                        name: 'Created At',
                        expressions: [filterConstants.EXPRESSION_GT, filterConstants.EXPRESSION_GTE, filterConstants.EXPRESSION_LT, filterConstants.EXPRESSION_LTE],
                        component: (setFilterValue, index) => {
                            const filters = catchQueryFilters();
                            const filter = filters[index];
                            return (
                                <DatePicker
                                    date={filter && filter.value ? filter.value : null}
                                    onChange={setFilterValue}/>
                            );
                        },
                    },
                    {
                        key: 'user_id',
                        name: 'Actor',
                        expressions: [filterConstants.EXPRESSION_EQUAL],
                        component: setFilterValue => {
                            return (
                                <UserDropdown
                                    id='action-logs-actor'
                                    onSelect={user => {
                                        if (user) {
                                            setFilterValue(user.id);
                                        } else {
                                            setFilterValue('');
                                        }

                                        return user ? user.fname + ' ' + user.lname : '';
                                    }}
                                    show_counts={true}
                                    debounce={debounce}
                                />
                            );
                        },
                        multiple: false
                    },
                    {
                        key: 'action_name',
                        name: 'Action',
                        expressions: [filterConstants.EXPRESSION_CONTAINS, filterConstants.EXPRESSION_NOT_CONTAINS],
                        values: [
                            {
                                label: 'switch class mode',
                                value: 'switch class mode'
                            },
                            {
                                label: 'teacher switch on raise hand',
                                value: 'teacher switch on raise hand'
                            },
                            {
                                label: 'student raise hand',
                                value: 'student raise hand'
                            },
                            {
                                label: 'student lower hand',
                                value: 'student lower hand'
                            },
                            {
                                label: 'teacher switch off raise hand',
                                value: 'teacher switch off raise hand'
                            },
                            {
                                label: 'teacher raise hand',
                                value: 'teacher raise hand'
                            },
                            {
                                label: 'teacher lower hand',
                                value: 'teacher lower hand'
                            },
                            {
                                label: 'teacher lower all hands',
                                value: 'teacher lower all hands'
                            },
                            {
                                label: 'teacher lower all hands',
                                value: 'teacher lower all hands'
                            },
                            {
                                label: 'User changed school',
                                value: 'User changed school'
                            }
                        ]
                    }
                ]}
                sort_columns={[
                    {
                        key: 'id',
                        name: 'ID'
                    },
                    {
                        key: 'created_at',
                        name: 'Created At'
                    }
                ]}
                entity={'action_logs'}
                default_order_direction='desc'
            >
                <Table/>
            </ListPage>
        </>
    );
}
